import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router';
import { GbgrundstueckService, GrundstueckDetailEntryMeta, GrundstueckId, TimePointId } from '../../core/gb-api';
import { TimepointService } from '../../core/services/timepoint.service';
import { AppConfigService } from '../../core/services/app-config.service';
import { NavTarget } from '../../shared/components/link/link.component';
import { Observable } from 'rxjs';
import { CapExceptionHandler } from '../../core/extension/exceptions/cap-exception-handler';
import { AbstractComponent } from '../../shared/components/abstract-component/abstract.component';
import { BreadcrumbComponent } from '../../shared/breadcrumb/breadcrumb.component';
import { GrundstueckMenuComponent } from '../menu/grundstueck-menu.component';
import { GrundstueckKopfComponent } from '../kopf/grundstueck-kopf.component';
import { CapSpinnerSmallComponent } from '../../shared/components/cap-spinner-small/cap-spinner-small.component';

@Component({
  selector: 'cap-grundstueck-detail',
  templateUrl: './grundstueck-detail.component.html',
  styleUrls: ['./grundstueck-detail.component.scss'],
  imports: [BreadcrumbComponent, GrundstueckMenuComponent, GrundstueckKopfComponent, RouterOutlet, CapSpinnerSmallComponent]
})
export class GrundstueckDetailComponent extends AbstractComponent implements OnInit {
  gsId: GrundstueckId;
  timepointId: TimePointId;

  loaded = false;

  grundstueckEntry: GrundstueckDetailEntryMeta;
  grundstueck$: Observable<GrundstueckDetailEntryMeta>;

  navTargets = NavTarget;

  constructor(
    private appConfigService: AppConfigService,
    private timepointService: TimepointService,
    private grundstueckService: GbgrundstueckService,
    private capExceptionHandler: CapExceptionHandler,
    private route: ActivatedRoute,
    private router: Router
  ) {
    super();
  }

  ngOnInit(): void {
    const z = this.timepointService.timepointCtx;
    this.route.queryParamMap.subscribe((q) => {
      this.gsId = { id: q.get('id') };
      if (q.get('egrid')) {
        this.grundstueck$ = this.grundstueckService.loadGrundstueckByEgrid(
          this.appConfigService.einstellungHistorischeDaten,
          q.get('egrid'),
          z.timepointIso,
          z.timepointId
        );
      } else {
        this.grundstueck$ = this.grundstueckService.loadGrundstueckByFachId(
          q.get('bfs'),
          q.get('kr'),
          q.get('n1'),
          q.get('n2'),
          q.get('n3'),
          q.get('n4')
        );
      }
      this.addSub(
        this.appConfigService.einstellungHistorischeDaten$.subscribe(() => {
          this.update();
          this.loaded = false;
        })
      );
    });
  }

  private update() {
    const z = this.timepointService.timepointCtx;
    if (this.gsId && this.gsId.id) {
      this.addSub(
        this.grundstueckService
          .loadGrundstueckById(this.gsId.id, this.appConfigService.einstellungHistorischeDaten, z.timepointIso, z.timepointId)
          .subscribe({
            next: (gsDetail) => (this.grundstueckEntry = gsDetail),
            error: (err) => this.handleError(err)
          })
      );
    } else if (this.grundstueck$) {
      this.addSub(
        this.grundstueck$.subscribe({
          next: (gsDetail) => {
            // Die Subkomponenten werden mit id geladen, da das <router-outlet> im ngIf für den grundstueckentry ist.
            this.router.navigate([], { relativeTo: this.route, queryParams: { id: gsDetail.id.id }, replaceUrl: true });
            this.gsId = gsDetail.id;
            this.grundstueckEntry = gsDetail;
          },
          error: (err) => this.handleError(err)
        })
      );
    }
  }

  private handleError(err: any) {
    if (err.status === 404) {
      this.router.navigate(['/home/notfound']);
      return;
    }
    if (err.status === 403) {
      this.router.navigate(['/security/forbidden']);
      return;
    }
    this.capExceptionHandler.handleError(err);
  }
}
